'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  &&& {
    width: 100%;
  }
`;

export const input = css`
  && {
    background: ${theme.colors.neutral['5']};
    border-radius: 26px;
    box-shadow: none;
    &:placeholder-shown {
      text-overflow: ellipsis;
    }
  }
`;

export const icon = css`
  color: ${theme.colors.neutral['3']};
`;
